// -------------------------------------------
//   ANIMATIONS > ROLL
// -------------------------------------------



// (((((((((( ~~~~~~~~~~ ROLL : IN ~~~~~~~~~~ )))))))))) //
const rollIn = {
	'@global': {
		// ***** ROLL : IN ***** //
		'@keyframes rollIn': {
			from: {
				opacity: '0',
				transform: 'translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg)'
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		},
		// ***** ROLL : IN : RIGHT ***** //
		'@keyframes rollInRight': {
			from: {
				transform: 'translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)'
			},
			to: {
				opacity: '1',
				transform: 'none'
			}
		}
	}
};


// (((((((((( ~~~~~~~~~~ ROLL : OUT ~~~~~~~~~~ )))))))))) //
const rollOut = {
	'@global': {
		// ***** ROLL : OUT ***** //
		'@keyframes rollOut': {
			from: {
				opacity: '1'
			},
			to: {
				opacity: '0',
				transform: 'translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)'
			}
		}
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { rollIn, rollOut };